import { difference } from '@vestigas/utils';

export const hasDifference = (arrayA: string[], arrayB: string[]): boolean => {
  return difference(arrayA, arrayB).some((item) => item.length > 0);
};
